import React from "react";
import { LoginLayout } from "../components";
import { RegisterForm } from "../features/auth";

const RegisterPage = () => (
  <LoginLayout>
    <RegisterForm />
  </LoginLayout>
);

export default RegisterPage;
